<template>
  <div class="m-content">
    <CareerMajor v-if="step1" :content="carrerArray" :mode="'explore'" v-on:listenToChildEvent="getListCareer"></CareerMajor>
    <CareerCategory v-if="step2" :content="listCareer" :selected="selected" :mode="'explore'" v-on:listenToChildEvent="getCareerCategory"></CareerCategory>
    <div class="career-selected">
      <p class="head-text">请选取4个职业，已选取<span>{{count}}</span>个</span></p>
      <ul class="label-box">
        <li class="career-label" :class="item?'current':''"v-for="(item,index) in selected">
          <span v-if="item">
            {{item.name}}（{{item.score}}%）
            <i class="iconfont icon-close icon-style" @click="removeCareer(item,index)" slot="reference" title="取消"></i>
          </span>
        </li>
      </ul>
      <button class="default-btn middle-btn" v-if="showButton" @click="Back" v-preventReClick>上一步</button>
      <button class="default-btn submit-btn" :class="showButton?'middle-btn':'large-btn'" @click="submit" v-preventReClick>确定</button>
    </div>
  </div>
</template>
<script>
import CareerCategory from '../components/CareerCategory.vue'
import CareerMajor from '../components/CareerMajor.vue'
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
import { mapState } from 'vuex'
  export default {
    props: {
      id: Number
    },
    name: 'CareerExplore',
    components: {
      'CareerCategory':CareerCategory,
      'CareerMajor':CareerMajor
    },
    data() {
      return {
        carrerArray:[
          [{'career':'金融','count':85},{'career':'政府与公共事务','count':17}],
          [{'career':'企业管理与行政','count':105},{'career':'法律、公共安全、惩教及保安','count':36}],
          [{'career':'教育&培训','count':47},{'career':'艺术、音像技术与传播','count':91}],
          [{'career':'科学、技术、工程和数学','count':109},{'career':'生产制造','count':204}],
          [{'career':'建筑与施工','count':90},{'career':'公共事业/社会服务','count':61}],
          [{'career':'运输、配送&物流','count':87},{'career':'酒店&旅游&休闲娱乐&体育','count':37}],
          [{'career':'农业、食品和自然资源','count':42},{'career':'市场营销','count':111}],
          [{'career':'信息技术','count':104},{'career':'医疗保健','count':151}],
        ],
        listCareer:[],
        selected:['','','',''],
        count:0,
        step1:true,
        step2:false,
        showButton:false,
        result:'',
        submitNum:0
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },
    created(){
      setWechatTitle('生涯驿站-职业世界探索');
    },
    methods: {
      getListCareer(arr){
        this.listCareer = arr
        this.step1 = false
        this.step2 = true
        this.showButton = true
      },
      getCareerCategory(category,carrer){
        this.count=0
        category.map((item,index)=>{
          if(item){
            this.count++
          }
        })
        this.selected = category
        this.listCareer = carrer
      },
      Back(){
        this.step1 = true
        this.step2 = false
        this.showButton = false
      },
      removeCareer(item,index){
        if(this.count>0){
          this.count--
        }
        this.$set(this.selected,index,'')
      },
      submit(){
        let submit = true
        this.selected.map((item,index)=>{
          if(!item){
            this.$store.commit('showMessage', {
              message:'必须选够4个职业',
              type: 'warning'
            })
            submit=false
          }
        })
        if(submit&&this.submitNum==0){
          this.submitNum = 1
          this.selected.map((item,index)=>{
            this.result+=(index+1)+'$1<'+item.name+',2<'+item.score+',3<'+item.hollandPreThree
            if((index+1)<4){
              this.result+='}'
            }
          })
          const options = {
            method: 'POST',
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify({
              submitdata: this.result,
              openId: this.shengyaUser.openid
            }),
            url: '/cob/saveCosCareerAnswer.do'
          };
          axios(options)
            .then((response)=>{
              if(response.data.result.success){
                let careerAnswer = response.data
                let shengyaUser = careerAnswer.data.user
                this.$bus.$emit('play-finish', shengyaUser)
              }else{
                this.$store.commit('showMessage', {
                  message: res.data.result.message,
                  type: 'error'
                })
              }
            })
            .catch((error)=>{
              console.log(error);
            });
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .m-content
    /deep/ .career-box
        max-height:60vh
    /deep/ .career-category
        max-height:55vh
  .career-selected
     position:fixed
     bottom:0
     width:100%
     max-width:12rem
    .head-text
      text-align:center
      font-weight:bold
      margin-top:0.5rem
    .label-box
      overflow:hidden
      .career-label
        float:left
        width:43%
        border:1px #BBBBBB dashed
        height:0.8rem
        margin:0.1rem
        padding:0.1rem
        border-radius:6px
        background-color:#F2F2F2
        display: flex;
        display:-webkit-flex;
        justify-content: left;/*水平居左*/
        align-items: center;/*垂直居中*/
        -webkit-align-items:center;
        span
          width:100%
        .icon-style
          color:#DC6E5A
          float:right
      .current
        border:1px #DC6E5A dashed
        background-color:#ffffff
    .default-btn
      margin:0.1rem
</style>
